import { render, staticRenderFns } from "./SimpleChildDetail.vue?vue&type=template&id=2b273d0c&scoped=true"
import script from "./SimpleChildDetail.vue?vue&type=script&lang=js"
export * from "./SimpleChildDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b273d0c",
  null
  
)

export default component.exports